import React, { useMemo } from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { useSortedCloseStages } from "@api/organizationCloseStage.api";
import { formatFilterLabel } from "./formatFilterLabel";

interface Props {
    filters: FiltersTypes;
}

export const TaskStageFilterLabel: React.FC<Props> = ({ filters }) => {
    const closeStages = useSortedCloseStages();
    const { taskCloseStageIds } = filters;

    const labels = useMemo(
        () =>
            closeStages
                .filter((stage) => taskCloseStageIds?.includes(stage.id))
                .map((stage) => stage.name),
        [closeStages, taskCloseStageIds],
    );

    if (!taskCloseStageIds || taskCloseStageIds.length === 0) {
        return null;
    }

    return formatFilterLabel(labels);
};
